export default __webpack_public_path__ + "static/media/SWT1560.34I-37702_-22109_0.73995f0e.jpg";